import { render, staticRenderFns } from "./ApprovalDocument.vue?vue&type=template&id=0e6ea6bf&scoped=true"
import script from "./ApprovalDocument.vue?vue&type=script&lang=js"
export * from "./ApprovalDocument.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDocument.vue?vue&type=style&index=0&id=0e6ea6bf&prod&lang=scss&scoped=true"
import style1 from "./ApprovalDocument.vue?vue&type=style&index=1&id=0e6ea6bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ea6bf",
  null
  
)

export default component.exports